import engineIsNode from './engine-is-node.mjs';

var IS_NODE = engineIsNode;

var tryNodeRequire = function (name) {
  try {
    // eslint-disable-next-line no-new-func -- safe
    if (IS_NODE) return Function('return require("' + name + '")')();
  } catch (error) { /* empty */ }
};

export { tryNodeRequire as default };
